import React from 'react';
import Logo from '../../assets/images/logo/logo.png'
import {Link} from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { } from '@fortawesome/free-solid-svg-icons';
import { faArrowAltCircleRight, faFaceSurprise } from '@fortawesome/free-regular-svg-icons';


const Header = (props) => {
const detail=props.detail


  return (
   <>
    <header>
        <nav className="navbar navbar-expand-lg navbar-light bg-white border-0 ">
            <div className="container">
                <Link className="navbar-brand" to="/">
                    <img src={Logo} alt="Logo" className="logo"/>
                </Link>
                
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse"
                    data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                    aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                
                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                {/* <Link to="/refer-a-friend" className='header_friendLink ms-auto d-none d-md-block' state={{detail:detail}}>Refer a Friend</Link> */}

                    <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
                        {
                            detail!==undefined && detail.profCompletePercentage ==100 &&
                            <li><a href="https://digitalclass.allenoverseas.com/login" target="_blank" className="pt-2 pe-2 d-inline-block">Go to ALLEN Overseas's LMS &nbsp;<FontAwesomeIcon color='green' icon={faArrowAltCircleRight}/></a></li>
                        }
                       
                        {/* <li className="nav-item dropdown">
                            <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button"
                                data-bs-toggle="dropdown" aria-expanded="false">
                                <i className="fa fa-bell"></i> Notification (5)
                            </a>
                            <ul className="dropdown-menu w-22 notific-dropdown" aria-labelledby="navbarDropdown">
                                <li><a className="dropdown-item text-center bg-light" href="/">Notifications List</a></li>
                                <li><a className="dropdown-item" href="/"><i className="fa fa-bell pe-2"></i> ASAT Exam scheduled on 14-03-2022.</a></li>
                                <li><a className="dropdown-item" href="/"><i className="fa fa-bell pe-2"></i> TALLENTEX Exam scheduled on 14-03-2022.</a></li>
                                <li><a className="dropdown-item" href="/"><i className="fa fa-bell pe-2"></i> TALLENTEX Exam scheduled on 14-03-2022.</a></li>
                                <li><a className="dropdown-item" href="/"><i className="fa fa-bell pe-2"></i> TALLENTEX Exam scheduled on 14-03-2022.</a></li>
                                <li><a className="dropdown-item" href="/"><i className="fa fa-bell pe-2"></i> TALLENTEX Exam scheduled on 14-03-2022.</a></li>
                                <li><Link className="dropdown-item text-center bg-light" to="/notifications">See All Notifications</Link></li>
                            </ul>
                        </li> */}
                        <li className="nav-item dropdown">
                            <Link className="nav-link dropdown-toggle" to="/" id="navbarDropdown" role="button"
                                data-bs-toggle="dropdown" aria-expanded="false">
                                Welcome <b><i className="fa fa-user-circle"></i> {detail && detail.name}</b>
                            </Link>
                            <ul className="dropdown-menu userDropdown" aria-labelledby="navbarDropdown">
                                <li><Link className="dropdown-item" to="/dashboard" state={{detail:detail}}><i className="fa fa-dashboard pe-2"></i> Dashboard</Link></li>
                                {/* <li><Link className="dropdown-item" to="/scholarships"><i className="fa fa-percentage pe-2"></i> Scholarship & Discounts</Link></li> */}
                                {/* {detail!==undefined && detail.is_paid ==1 && <li><Link className="dropdown-item" to="/enrollment" state={{detail:detail}}><i className="fa fa-address pe-2"></i> Enrollment</Link></li>} */}
                                {/* <li><Link className="dropdown-item d-block d-md-none" to="/refer-a-friend" state={{detail:detail}}> <i className="fa fa-dashboard pe-2"></i> Refer a friend</Link></li> */}
                                <li><Link className="dropdown-item" to={`/my-transactions/${detail?.id}`}><i className="fa fa-credit-card pe-2"></i> My Transactions</Link></li>
                                <li><Link className="dropdown-item" to="/change-password" state={{detail:detail}}><i className="fa fa-key pe-2"></i> Change Password</Link></li>
                                <li><Link className="dropdown-item" to="/login" onClick={()=>sessionStorage.clear()}><i className="fa fa-sign-out pe-2"></i> Logout</Link></li>
                            </ul>
                        </li>
                    </ul>

                </div>
                
                
            </div>
        </nav>
    </header>
   </>
  )
}

export default Header
